import axios from 'axios';
import routes from "../routes";

const defaultOptions = {
    baseURL: "https://apibeta.sistemaclin.com.br/",
    withCredentials: true,
}

const api = axios.create(defaultOptions);

api.interceptors.request.use(function (config) {
    config.headers["requester"] = "admin";
    return config;
});

api.interceptors.response.use(response => {
    if (response.status == 401) {
        let { admin, permissions } = response.data;
        if (admin && permissions) {
            sessionStorage.setItem("admin", JSON.stringify(admin));
            sessionStorage.setItem("permissions", JSON.stringify(permissions));
            return api.request(response.config);
        } else {
            routes.push({ name: "signin" });
        }
    }
    return response;
}, error => {
    if (error.response.status == 401) {
        let { admin, permissions } = error.response.data;
        if (admin && permissions) {
            sessionStorage.setItem("admin", JSON.stringify(admin));
            sessionStorage.setItem("permissions", JSON.stringify(permissions));
            return api.request(error.response.config);
        } else {
            routes.push({ name: "signin" });
        }
    }
    return error.response;
});

export default api;
